(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunriao-specification-style-tags"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-sunriao-style-tags]';
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const initialize = (root) => {
      if (!root || root.dataset.collapseReady === 'true') return;

      const tags = Array.from(root.querySelectorAll('.sunriao-style-tags__tag'));
      const toggle = root.querySelector('.sunriao-style-tags__toggle');
      const label = root.querySelector('[data-sunriao-style-toggle-label]');
      const rowLimit = Math.max(1, Number.parseInt(root.dataset.mobileRows, 10) || 3);

      if (!tags.length || !toggle || !label) return;

      const update = () => {
        tags.forEach((tag) => tag.classList.remove('sunriao-style-tags__tag--mobile-hidden'));

        if (!mobileQuery.matches) {
          root.dataset.collapsible = 'false';
          toggle.hidden = true;
          return;
        }

        const rowTops = [];
        const tagRows = tags.map((tag) => {
          const top = Math.round(tag.offsetTop);
          let rowIndex = rowTops.findIndex((rowTop) => Math.abs(rowTop - top) <= 2);

          if (rowIndex === -1) {
            rowTops.push(top);
            rowIndex = rowTops.length - 1;
          }

          return rowIndex;
        });
        const collapsible = rowTops.length > rowLimit;
        const expanded = root.dataset.expanded === 'true';

        root.dataset.collapsible = String(collapsible);
        toggle.hidden = !collapsible;
        toggle.setAttribute('aria-expanded', String(expanded));
        label.textContent = expanded ? toggle.dataset.showLess : toggle.dataset.showMore;

        if (collapsible && !expanded) {
          tags.forEach((tag, index) => {
            if (tagRows[index] >= rowLimit) {
              tag.classList.add('sunriao-style-tags__tag--mobile-hidden');
            }
          });
        }
      };

      toggle.addEventListener('click', () => {
        root.dataset.expanded = String(root.dataset.expanded !== 'true');
        update();
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(update, 120);
      });

      root.dataset.collapseReady = 'true';
      update();

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(update);
      }
    };

    const initializeAll = (scope) => {
      if (scope.matches && scope.matches(selector)) initialize(scope);
      scope.querySelectorAll(selector).forEach(initialize);
    };

    initializeAll(document);
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
